module.exports = __webpack_public_path__ + "img/img7.d6b44c21.png";